import React, { useEffect, useState } from "react";
import "./DateRangePicker.css";

interface YearPickerProps {
	value?: Date;
	onClear?: () => void;
	onChange: (date: Date) => void;
	onReset: () => void;
	onConfirm: (date: Date) => void;
}

export default function YearPicker(props: YearPickerProps) {
	const { value, onClear, onChange, onReset, onConfirm } = props;

	const today = new Date();
	const initialDate = value ?? today;
	const initialYear = initialDate.getFullYear();

	const [year, setYear] = useState<number>(initialYear);

	useEffect(() => {
		const d = value ?? today;
		setYear(d.getFullYear());
	}, [value]);

	const handleYearChange = (increment: number) => {
		setYear((prev) => {
			const next = prev + increment;
			onChange(new Date(next, 0, 1));
			return next;
		});
	};

	const handleYearSelect = (y: number) => {
		setYear(y);
		onChange(new Date(y, 0, 1));
	};

	const handleConfirm = () => {
		onConfirm(new Date(year, 0, 1));
	};

	const handleCancel = () => {
		onConfirm(initialDate);
	};

	const years = Array.from(
		{ length: 200 },
		(_, i) => today.getFullYear() - 100 + i,
	);

	return (
		<div className="custom-range-picker-popup single-calendar-popup">
			<div className="month-picker-container">
				<div className="calendar-header">
					<button type="button" onClick={() => handleYearChange(-1)}>
						{"≪"}
					</button>
					<select
						value={year}
						onChange={(e) => handleYearSelect(Number(e.target.value))}
						className="month-picker-year-select"
					>
						{years.map((y) => (
							<option key={y} value={y}>
								{y}년
							</option>
						))}
					</select>
					<button type="button" onClick={() => handleYearChange(1)}>
						{"≫"}
					</button>
				</div>
			</div>

			<div className="calendar-btns">
				<div className="left-btns">
					<button type="button" className="cancel" onClick={handleCancel}>
						취소
					</button>
					{onClear && (
						<button type="button" className="cancel" onClick={onClear}>
							비우기
						</button>
					)}
				</div>
				<div className="right-btns">
					<button type="button" className="reset" onClick={onReset}>
						올해
					</button>
					<button type="button" className="confirm" onClick={handleConfirm}>
						확인
					</button>
				</div>
			</div>
		</div>
	);
}
